<snl-modal (modalClose)="closePopup()" [settings]="snlModalSettings" [type]="'medium'" [open]="true"
    class="CenterModelCmn CommonPhoneCstm CustomiseMyView__modal Nps_Survey_Model">
    <div class="body-b" slot="modalContent" *ngIf="userId">
        <iframe width="100%" height="1300px" title="SurveyMonkey Survey" allowfullscreen
        [src]="url"></iframe>
    </div>
</snl-modal>